import { isNotUndefined } from './Utils';
export const classNames = (...values) => {
    return values
        .map((value) => (typeof value === 'string' ? value : null))
        .filter(isNotUndefined)
        .join(' ');
};
